interface ProjectsListNavState {
  onlyMyProjects?: unknown;
}

// Scope the listing to assigned projects when the caller asks, or when the link that navigated here did.
export const resolveOnlyMyProjects = (
  propValue: boolean | undefined,
  navState: ProjectsListNavState | null | undefined,
): boolean => propValue === true || navState?.onlyMyProjects === true;

export default resolveOnlyMyProjects;
